import React, { useState, useEffect, useRef } from "react";
import BatchUpload from "./BatchUpload";
import { Button } from "flowbite-react";
import { RefreshCcw } from "lucide-react";
const Filters = ({ filters, onFilterChange, onDateChange, ResetFilters }) => {
  const [isRangeOpen, setIsRangeOpen] = useState(false);

  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsRangeOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (range) => {
    onFilterChange("range", range);
    setIsRangeOpen(false);
  };

  return (
    <div className="mt-4 mb-4 p-4 bg-white dark:bg-gray-800  flex flex-row items-center space-x-4 justify-between ">
      <div className="flex flex-row space-x-2">
        <div>
          <input
            value={filters.batchName || ""}
            onChange={(e) => onFilterChange("batchName", e.target.value)}
            className="dark:bg-slate-800 dark:text-white rounded-md outline-none p-2 border-[1px] border-slate-300"
            placeholder="Batch name"></input>
        </div>
        <div className="flex items-center space-x-1  dark:bg-gray-800 dark:text-white">
          <h3>Date debut</h3>
          <input
            className=" dark:bg-gray-800 dark:text-white cursor-pointer rounded-md border-[1px] border-slate-300"
            type="date"
            value={filters.date.startDate || ""}
            onChange={(e) => onDateChange("startDate", e.target.value)}></input>
        </div>
        <div className="flex items-center space-x-1 dark:text-white">
          <h3 className="">Date fin</h3>
          <input
            className="dark:bg-gray-800 dark:text-white cursror-pointer rounded-md border-[1px] border-slate-300"
            type="date"
            value={filters.date.endDate || ""}
            onChange={(e) => onDateChange("endDate", e.target.value)}></input>
        </div>
        <div className="relative" ref={dropdownRef}>
          <button
            className="text-black  px-4 py-2 dark:bg-gray-800 dark:text-white rounded-lg flex items-center justify-between border-[1px] border-slate-300"
            onClick={() => {
              setIsRangeOpen(!isRangeOpen);
            }}>
            <h2>{filters.range ? `${filters.range}` : "Select Range"}</h2>
          </button>
          {isRangeOpen && (
            <ul className="absolute bg-white border mt-2 w-40 z-30">
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect("1000-40000")}>
                1000-40000
              </li>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect("40000-60000")}>
                40000-60000
              </li>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect("60000-100000")}>
                60000-100000
              </li>
            </ul>
          )}
        </div>
      </div>
      {/* // button wrapper */}
      <div className="flex flex-row gap-3">
        <BatchUpload />

        <Button
          color={"dark"}
          pill
          size="xs"
          title="Refresh"
          onClick={ResetFilters}>
          <RefreshCcw size={18} />
        </Button>
      </div>
    </div>
  );
};

export default Filters;
